<template>
  <div>
    <Layout/>
    <h4>Tipos de Identificación</h4>
<!-- Master -->
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idTipoIden" class="form-label">IdTipoIden</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idTipoIden" name="idTipoIden" v-model="datoTipoIden.idTipoIden" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="nombre" class="form-label">Nombre</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="nombre" name="nombre" v-model="datoTipoIden.nombre" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" @click.prevent="cerrarTipoIden" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
        <button type="submit" class="btn btn-light" @click.prevent="guardarTipoIden" v-if="btnCrear" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditTipoIden" v-if="btnEditar" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>

<!-- Details -->
    <hr>
      <div class="mb-3">
        <table class="tablaBusqueda">
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPagina(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Nuevo registro">
                <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>
              </button>
            </td>
          </tr>
        </table>
      </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col">IdPersona</th>
          <th scope="col">IdEmpresa</th>
          <th scope="col">IdTipoIden</th>
          <th scope="col">IdLocalidad</th>
          <th scope="col">IdEstadoCivil</th>
          <th scope="col">Documento</th>
          <th scope="col">PrimerNombre</th>
          <th scope="col">SegundoNombre</th>
          <th scope="col">PrimerApellido</th>
          <th scope="col">SegundoApellido</th>
          <th scope="col">FechaNac</th>
          <th scope="col">Direccion</th>
          <th scope="col">Telefono</th>
          <th scope="col">TipoPersona</th>
          <th scope="col">Sexo</th>
          <th scope="col">Email</th>
          <th scope="col">FechaReg</th>
          <th scope="col">Estado</th>
          <th scope="col">EmpresaNombre</th>
          <th scope="col">TipoIdenNombre</th>
          <th scope="col">LocalidadNombre</th>
          <th scope="col">EstadoCivilNombre</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="persona in datosPaginados" :key="persona.idPersona">
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirModalEditar(persona.idPersona)" title="Editar">edit_square</i></td>
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirEditar(persona.idPersona)" title="Editar">edit_square</i></td>
          <td>{{persona.idPersona}}</td>
          <td>{{persona.idEmpresa}}</td>
          <td>{{persona.idTipoIden}}</td>
          <td>{{persona.idLocalidad}}</td>
          <td>{{persona.idEstadoCivil}}</td>
          <td>{{persona.documento}}</td>
          <td>{{persona.primerNombre}}</td>
          <td>{{persona.segundoNombre}}</td>
          <td>{{persona.primerApellido}}</td>
          <td>{{persona.segundoApellido}}</td>
          <td>{{getFormattedDate(persona.fechaNac, 'DD/MM/YYYY')}}</td>
          <td>{{persona.direccion}}</td>
          <td>{{persona.telefono}}</td>
          <td>{{persona.tipoPersona}}</td>
          <td>{{persona.sexo}}</td>
          <td>{{persona.email}}</td>
          <td>{{getFormattedDate(persona.fechaReg, 'DD/MM/YYYY')}}</td>
          <td>{{persona.estado}}</td>
          <td>{{persona.empresaNombre}}</td>
          <td>{{persona.tipoIdenNombre}}</td>
          <td>{{persona.localidadNombre}}</td>
          <td>{{persona.estadoCivilNombre}}</td>
          <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;" @click="deleteTipoIden(persona.idPersona)" title="Borrar">delete</i></td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPagina(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar_det">
              <div class="row">
                <div class="col-2">
                  <label for="idPersona" class="form-label">IdPersona</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idPersona" name="idPersona" v-model="datoPersona.idPersona" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <input type="hidden" class="form-control" id="idEmpresa" name="idEmpresa" v-model="datoPersona.idEmpresa"
                disabled>
                <div class="row">
                  <div class="col-2">
                    <label for="idEmpresa" class="form-label"> Empresa</label>
                  </div>
                  <div class="col-9">
                    <input type="text" class="form-control" id="empresa" name="empresa" v-model="datoPersona.empresa" disabled>
                  </div>
                  <div class="col-1">
                    <button type="button" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ModalEmpresaLOV"
                      title="Buscar Empresas">
                      <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">manage_search</i>
                    </button>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idTipoIden" class="form-label">IdTipoIden</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idTipoIden" name="idTipoIden" v-model="datoPersona.idTipoIden" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <input type="hidden" class="form-control" id="idLocalidad" name="idLocalidad" v-model="datoPersona.idLocalidad"
                disabled>
                <div class="row">
                  <div class="col-2">
                    <label for="idLocalidad" class="form-label"> Localidad</label>
                  </div>
                  <div class="col-9">
                    <input type="text" class="form-control" id="localidad" name="localidad" v-model="datoPersona.localidad" disabled>
                  </div>
                  <div class="col-1">
                    <button type="button" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ModalLocalidadLOV"
                      title="Buscar Localidades">
                      <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">manage_search</i>
                    </button>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <input type="hidden" class="form-control" id="idEstadoCivil" name="idEstadoCivil" v-model="datoPersona.idEstadoCivil"
                disabled>
                <div class="row">
                  <div class="col-2">
                    <label for="idEstadoCivil" class="form-label"> Estado Civil</label>
                  </div>
                  <div class="col-9">
                    <input type="text" class="form-control" id="estadoCivil" name="estadoCivil" v-model="datoPersona.estadoCivil" disabled>
                  </div>
                  <div class="col-1">
                    <button type="button" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ModalEstadoCivilLOV"
                      title="Buscar Estado Civil">
                      <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">manage_search</i>
                    </button>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="documento" class="form-label">Documento</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="documento" name="documento" v-model="datoPersona.documento" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="primerNombre" class="form-label">PrimerNombre</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="primerNombre" name="primerNombre" v-model="datoPersona.primerNombre" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="segundoNombre" class="form-label">SegundoNombre</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="segundoNombre" name="segundoNombre" v-model="datoPersona.segundoNombre" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="primerApellido" class="form-label">PrimerApellido</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="primerApellido" name="primerApellido" v-model="datoPersona.primerApellido" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="segundoApellido" class="form-label">SegundoApellido</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="segundoApellido" name="segundoApellido" v-model="datoPersona.segundoApellido" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaNac" class="form-label">FechaNac</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaNac" name="fechaNac" v-model="datoPersona.fechaNac" required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="direccion" class="form-label">Dirección</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="direccion" name="direccion" v-model="datoPersona.direccion" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="telefono" class="form-label">Telefono</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="telefono" name="telefono" v-model="datoPersona.telefono" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="tipoPersona" class="form-label">TipoPersona</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="tipoPersona" name="tipoPersona" v-model="datoPersona.tipoPersona" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="sexo" class="form-label">Sexo</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="sexo" name="sexo" v-model="datoPersona.sexo" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="email" class="form-label">Email</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="email" name="email" v-model="datoPersona.email" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaReg" class="form-label">FechaReg</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaReg" name="fechaReg" v-model="datoPersona.fechaReg" required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
<!--
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
-->
        <button type="submit" class="btn btn-light" @click.prevent="guardarPersona" v-if="btnCrear_det" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditPersona" v-if="btnEditar_det" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>
</div>
<!-- Details -->

<!--
Listas de valores master
-->
<!--
Listas de valores master
-->
<!--
Listas de valores details
-->
<!-- Lista de Valores: Persona -->
    <PersonaLOVdet @DatosPersona="GetDataPersonaLOVdet($event)"/>
<!-- Lista de Valores: Empresa -->
    <EmpresaLOVdet @DatosEmpresa="GetDataEmpresaLOVdet($event)"/>
<!-- Lista de Valores: Localidad -->
    <LocalidadLOVdet @DatosLocalidad="GetDataLocalidadLOVdet($event)"/>
<!-- Lista de Valores: EstadoCivil -->
    <EstadoCivilLOVdet @DatosEstadoCivil="GetDataEstadoCivilLOVdet($event)"/>
<!--
Listas de valores details
-->
    <Footer/>
  </div>
</template>
<script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'
// Listas de valores master
// Listas de valores master
// Listas de valores details
import PersonaLOVdet from '../../components/lovs/PersonaLOV.vue'
import EmpresaLOVdet from '../../components/lovs/EmpresaLOV.vue'
import LocalidadLOVdet from '../../components/lovs/LocalidadLOV.vue'
import EstadoCivilLOVdet from '../../components/lovs/EstadoCivilLOV.vue'
// Listas de valores details
import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  components : {
    Layout, Footer
// Listas de valores master
// Listas de valores master
// Listas de valores details
, PersonaLOVdet
, EmpresaLOVdet
, LocalidadLOVdet
, EstadoCivilLOVdet
// Listas de valores details
  },
  data () {
    return {
// Variables master
      tipoidens : [],
      datoTipoIden : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      p_idTipoIden: '',
// Variables master
// Variables details
      personas : [],
      datoPersona : {},
      nombreBusqueda_det: '',
      titulo_det: '',
      btnCrear_det: false,
      btnEditar_det: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true
// Variables details
    }
  },
  mounted () {
    this.p_idTipoIden = this.$route.params.p_idtipoiden
    this.abrirEditar(this.p_idTipoIden)
    this.getPersonas()
    this.getDataPagina(this.paginaActual)
  },
  methods : {
// Procedimientos master
    validarForm(){
      if(this.datoTipoIden.idTipoIden === ''){
        swal("Error!", "El elemento idTipoIden no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoTipoIden.nombre === ''){
        swal("Error!", "El elemento nombre no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoTipoIden.estado === ''){
        swal("Error!", "El elemento estado no puede ser nulo.", "error");
        return 0;
      }
      return 1;
    },
    async guardarTipoIden(){
      if(this.validarForm() === 1){
        try {
          await api.post('/tipoidens', this.datoTipoIden)
          swal("Correcto!", "TipoIden creada exitosamente!", "success");
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditTipoIden(){
      if(this.validarForm() === 1){
        try {
          await api.post('/tipoidens', this.datoTipoIden)
          swal("Correcto!", "TipoIden creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirCrear(){
      this.modalWindow = true
      this.datoTipoIden={}
      this.titulo   = 'Crear Tipos de Identificación'
      this.btnCrear = true
      this.btnEditar= false
    },
    abrirEditar(idTipoIden){
      this.modalWindow = true
      if(idTipoIden != null){    
           api.get('/vwtipoidens/'+idTipoIden).then(resp=>{
          this.datoTipoIden = resp.data;
           });
      }
      this.titulo   = 'Editar Tipos de Identificación'
      this.btnCrear = false
      this.btnEditar= true
    },
    cerrarTipoIden(){
      this.$router.push('/TipoIden')
    },
// Procedimientos master
// Procedimientos detalle
    async getPersonas() {
      const resp = await api.get('/personas')
      this.personas = resp.data
    },
    totalPaginas(){
      return Math.ceil(this.personas.length / this.elementosPorPagina)
    },
    getDataPagina(noPagina){
      if(this.nombreBusqueda != '') {
        api.get('/vwpersonas/nombre/'+this.nombreBusqueda).then(response=>{
          this.personas=response.data.reverse();  
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
          let fin = (noPagina * this.elementosPorPagina);
          this.datosPaginados = this.personas.slice(ini,fin);
        });
      }
    },
    getDataPaginaTodos(noPagina){
      api.get('/vwpersonas').then(response=>{
      this.personas=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.personas.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarFormDet(){
      if(this.datoPersona.idTipoIden === ''){
        swal("Error!", "El elemento idTipoIden no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoPersona.nombre === ''){
        swal("Error!", "El elemento nombre no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoPersona.estado === ''){
        swal("Error!", "El elemento estado no puede ser nulo.", "error");
        return 0;
      }
      return 1;
    },
    async guardarPersona(){
      if(this.validarForm() === 1){
        try {
          this.datoPersona.idTipoIden = this.datoTipoIden.idTipoIden;
          await api.post('/personas', this.datoPersona)
          this.getPersonas();
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "Persona creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditPersona(){
      if(this.validarForm() === 1){
        try {
          await api.post('/personas', this.datoPersona)
          $('#ventanaModal').modal('hide');
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "Persona creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear(){
      this.modalWindow = true
      this.datoPersona={}
      this.titulo   = 'Crear Tipos de Identificación'
      this.btnCrear_det  = true
      this.btnEditar_det = false
    },
    abrirModalEditar(idPersona){
      this.modalWindow = true
      if(idPersona != null){    
           api.get('/vwpersonas/'+idPersona).then(resp=>{
          this.datoPersona = resp.data;
           });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Editar Tipos de Identificación'
      this.btnCrear_det  = false
      this.btnEditar_det = true
    },
    abrirEditarDet(idPersona){
      this.modalWindow = true
      if(idPersona != null){
        this.$router.push('/personamd/'+idPersona)
      }
    },
    async deletePersona (idPersona) {
      try{
        await api.delete('/personas/'+idPersona)
          this.getPersonas()
          this.getDataPagina(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    },
// Procedimientos detalle
// Listas de valores master
// Listas de valores master
// Listas de valores details
//    Lista de Valores
    GetDataPersonaLOVdet(data) {
      this.datoPersona.idPersona = data.idPersona;
      this.datoPersona.persona = data.nombre;
    },
//    Lista de Valores
    GetDataEmpresaLOVdet(data) {
      this.datoPersona.idEmpresa = data.idEmpresa;
      this.datoPersona.empresa = data.nombre;
    },
//    Lista de Valores
    GetDataLocalidadLOVdet(data) {
      this.datoPersona.idLocalidad = data.idLocalidad;
      this.datoPersona.localidad = data.nombre;
    },
//    Lista de Valores
    GetDataEstadoCivilLOVdet(data) {
      this.datoPersona.idEstadoCivil = data.idEstadoCivil;
      this.datoPersona.estadoCivil = data.nombre;
    },
// Listas de valores details
  },
}
</script>
